/**
 * @public
 */
export var String;
(function (String) {
    let Transformer;
    (function (Transformer) {
        /**
         * Transform a string if it matches a predicate
         */
        function when(predicate, transformer) {
            return (input) => (predicate(input) ? transformer(input) : input);
        }
        Transformer.when = when;
        /**
         * Chains transformers on a string.
         */
        function and(...transformers) {
            return (input) => transformers.reduce((input, transformer) => transformer(input), input);
        }
        Transformer.and = and;
    })(Transformer = String.Transformer || (String.Transformer = {}));
    /**
     * Adds two spaces at the start of each line.
     */
    function indent(input) {
        return input.replace(/^/gm, "  ");
    }
    String.indent = indent;
    /**
     * Collapses adjacent whitespace into a single ASCII space
     */
    function flatten(input) {
        return input.replace(/\s+/g, " ");
    }
    String.flatten = flatten;
    /**
     * Trims, collapses adjacent whitespace into a single ASCII space, optionally
     * lowercases (default: true).
     */
    function normalize(input, toLowerCase = true) {
        return flatten(toLowerCase ? input.toLowerCase() : input).trim();
    }
    String.normalize = normalize;
    /**
     * Removes all punctuation (underscore, hyphen, brackets, quotation marks,
     * etc)
     *
     * @remarks
     * This removes the Unicode classes P (punctuation), S (symbols),
     * and Cf (formatting characters).
     */
    function removePunctuation(input) {
        return input.replace(/\p{P}|\p{S}|\p{Cf}/gu, "");
    }
    String.removePunctuation = removePunctuation;
    function toLowerCase(input) {
        return input.toLowerCase();
    }
    String.toLowerCase = toLowerCase;
    /**
     * Checks whether the input contains only whitespace, optionally allowing
     * empty strings (default: true).
     */
    function isWhitespace(input, allowEmpty = true) {
        return (allowEmpty || input.length > 0) && input.trim() === "";
    }
    String.isWhitespace = isWhitespace;
    /**
     * Fallback to a default value if the input is empty or whitespace
     */
    function fallback(fallback) {
        return Transformer.when(isWhitespace, () => fallback);
    }
    String.fallback = fallback;
    /**
     * Checks whether the input contains a whitespace
     */
    function hasWhitespace(input) {
        return /\s/.test(input);
    }
    String.hasWhitespace = hasWhitespace;
    /**
     * Checks whether the string contains soft break points
     * {@link https://drafts.csswg.org/css-text/#line-breaking}
     *
     * @remarks
     * Spaces are always soft break points. Other are hard to correctly detect.
     * We do not want here to have a full break point detection which, based on
     * language, requires lexical analysis.
     * We accept punctuation as soft break points since they would act so in most
     * Western languages.
     */
    function hasSoftWrapOpportunity(input) {
        return /\s|\p{P}/u.test(input);
    }
    String.hasSoftWrapOpportunity = hasSoftWrapOpportunity;
})(String || (String = {}));
//# sourceMappingURL=string.js.map